<template>
  <div class="row">
    <div class="col-12">
      <div class="mb10" v-if="$route.params.backVoucher">
        <el-button type="primary" plain @click="backVoucher"
          >返回請款單 {{ $route.params.backVoucher }}</el-button
        >
      </div>

      <div class="col-block">
        <div class="block-header has-border">
          <h3 class="ml-2">
            <strong>請款單開立傳票</strong>
          </h3>
        </div>
        <div class="block-content">
          <!-- 收款對象 -->

          <el-card class="box-card">
            <div>
              <span class="mr10" style="font-size: 16px; font-weight: bold"
                >交易日期 :</span
              >
              <div class="date mt10">
                <input
                  type="text"
                  class="chooseDate min_go_date date date1"
                  placeholder="選擇日期"
                />
                <span class="el-input__prefix">
                  <i class="el-icon-date"></i>
                </span>
              </div>
              &nbsp;
              <!--如果是放款在顯示-->
              <el-button
                type="prinmary"
                plain
                v-if="invoice.operationTypeKey == 2"
                @click="recalculateVoucher()"
                >重新計算金額</el-button
              >
            </div>

            <table class="table table-bordered mb-0 mt10">
              <thead class="grey lighten-4">
                <tr>
                  <th>操作</th>
                  <th>社員帳號</th>
                  <th>科目名稱</th>
                  <th>借/貸方</th>
                  <th>金額</th>
                  <th>摘要</th>
                  <th>借據編號</th>
                  <th>安基代辦申請單號</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, itemIndex) of works" :key="itemIndex">
                  <td>
                    <el-button
                      type="danger"
                      plain
                      v-if="item.removeable == true"
                      @click="removeItem(item, itemIndex)"
                      >移除項目</el-button
                    >
                  </td>
                  <td>
                    {{ item.memberAccount }}
                    {{ item.memberName }}
                  </td>
                  <td>
                    {{ item.accountTitleCode }}
                    {{ item.accountTitleName }}
                  </td>
                  <td>
                    <el-select
                      v-model="item.by"
                      placeholder="請選擇"
                      :disabled="
                        item.changeDc !== undefined && item.changeDc == false
                      "
                    >
                      <el-option
                        v-for="(item, index) in byData"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </td>
                  <td>
                    <el-input
                      v-model="item.amount"
                      :disabled="item.disabled"
                      placeholder="請輸入金額"
                      v-on:input="resetAmount(item.amount, itemIndex)"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      type="textarea"
                      placeholder="請輸入摘要"
                      v-model="item.Summary"
                    ></el-input>
                  </td>
                  <td>{{ item.show }}</td>
                  <td>
                    {{ item.insCadreApplyNumberShow }}
                    {{ item.insEmployeeApplyNumberShow }}
                    {{ item.insPlanApplyNumberShow }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt10">
              <el-button plain @click="openAddItem(), (isWait = false)"
                >新增傳票項目</el-button
              >
            </div>

            <!-- 中文詞彙 插入 -->
            <h3 class="mt10">備註</h3>
            <el-select
              class="el-select ml10 mt10"
              placeholder="中文詞彙"
              v-model="Glossary"
            >
              <el-option
                :value="item.value"
                :label="item.label"
                v-for="(item, index) in GlossaryList"
                :key="index"
              ></el-option>
            </el-select>

            <el-button
              type="primary"
              plain
              class="ml10"
              @click="importGlossary"
            >插入</el-button>
            <el-input
              class="mt10"
              v-model="note"
              type="textarea"
              placeholder="請輸入內容"
            ></el-input>
          </el-card>

          <el-form label-position="left" label-width="100px">
            <el-form-item label="借方金額">{{ debitAmountTotal }}</el-form-item>
            <el-form-item label="貸方金額">{{
              creditAmountTotal
            }}</el-form-item>
          </el-form>
          <el-button
            class="mr10"
            type="primary"
            plain
            @click="checkItem"
            v-if="!btnShow"
            >送出</el-button
          >
          <el-button class plain @click="back">返回</el-button>
        </div>
        <!-- 新增收款項目 -->
        <el-dialog
          :visible.sync="dialogAddItem"
          :works="works"
          :append-to-body="true"
          width="370px"
        >
          <el-form label-position="top">
            <el-form>
              <el-form-item label="選擇社員" class="label-set">
                <el-radio-group
                  v-model="currentAddItem.objectType"
                  @change="filterType"
                >
                  <el-radio :label="3">社</el-radio>
                  <el-radio v-if="invoice.operationTypeKey != 2" :label="0"
                    >準社員</el-radio
                  >
                  <el-radio v-if="invoice.operationTypeKey != 2" :label="1"
                    >社員</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-form>

            <ListForm
              api="member"
              :recordToEdit="addMemberObj"
              labelPosition="top"
              :formType="formType"
              :filter="memberFilter"
              ref="removeMember"
            >
              <div slot="footer" class="dialog-footer"></div>
            </ListForm>
            <el-form-item label="新增項目">
              <el-select
                placeholder="請選擇類別"
                v-model="currentAddItem.type"
                style="width: 100%"
                @change="chooseType"
              >
                <el-option
                  v-for="item in options"
                  v-if="
                    invoice.operationTypeKey == 12 ||
                    invoice.operationTypeKey == 11 ||
                    (item.value !== 2 && item.value !== 8)
                  "
                  :key="item.value"
                  :label="item.code + ' ' + item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                placeholder="請選擇方案"
                class="mt10"
                :filterable="true"
                v-model="currentAddItem.chooseRepayment"
                v-show="
                  currentAddItem.type === 2 ||
                  currentAddItem.type === 3 ||
                  currentAddItem.type === 5 ||
                  currentAddItem.type === 4 ||
                  currentAddItem.type === 6 ||
                  currentAddItem.type === 8
                "
                @change="
                  (val) => {
                    getAmount(val);
                  }
                "
              >
                <el-option
                  v-for="option of iouList"
                  :key="option.id"
                  :label="
                    currentAddItem.type === 2
                      ? `${option.iouNumber}`
                      : currentAddItem.type === 5
                      ? `${option.label}`
                      : option.label
                  "
                  :value="
                    currentAddItem.type === 2
                      ? `${option.iouNumber}`
                      : currentAddItem.type === 5
                      ? `${option.value}`
                      : currentAddItem.type == 3
                      ? option
                      : option.value
                  "
                ></el-option>
              </el-select>
              <el-select
                placeholder="請選擇年度"
                class="mt10"
                :filterable="true"
                v-model="selectYear"
                v-show="currentAddItem.type == 7"
                @change="
                  (val) => {
                    getAmount(val);
                  }
                "
              >
                <el-option
                  v-for="option of yearList"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="金額">
              <el-input
                v-model="currentAddItem.amount"
                :disabled="inputDsabled"
                v-on:input="resetAddAmount(currentAddItem.amount)"
              ></el-input>
            </el-form-item>
            <el-form-item label="借/貸方">
              <el-radio-group v-model="currentAddItem.by" class="flex">
                <el-radio :label="1" :key="1">借方</el-radio>
                <el-radio :label="0" :key="0">貸方</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="摘要">
              <el-input
                type="textarea"
                v-model="currentAddItem.Summary"
              ></el-input>
            </el-form-item>
            <el-form-item label="理事會審查紀錄">
              <el-select
                placeholder="請選擇方案"
                class="mt10"
                :filterable="true"
                v-model="currentAddItem.meetRecord"
              >
                <!-- option.insPlanMainName -->
                <el-option
                  v-for="(item, key) in meetRc"
                  :key="key"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogAddItem = false">取消</el-button>
            <el-button type="primary" @click="saveAddItem">確定</el-button>
          </div>
        </el-dialog>
        <!-- 列印 -->
        <el-dialog
          :visible.sync="dialogPrint"
          :modal-append-to-body="false"
          :append-to-body="true"
        >
          <el-form label-position="left" label-width="100px">
            <el-form-item label="傳票日期">
              {{ $transferDate(currentPrint.voucherDate) }}
            </el-form-item>
            <el-form-item label="傳票號碼">
              {{ currentPrint.voucherCode }}
            </el-form-item>
          </el-form>
          <el-button type="primary" plain @click="print">PDF 列印</el-button>
          <el-button type="primary" plain @click="overprint"
            >點陣印表機 套印</el-button
          >
          <div slot="footer" class="dialog-footer"></div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";

export default {
  name: "all_payment_summons",
  components: { ListForm },
  data() {
    return {
      toDay: "",
      memberFilter: {
        isFormal: "",
      },
      selectYear: "",
      isWait: false,
      inputDsabled: false,
      test: {},
      meetRc: [],
      debitAmountTotal: 0,
      creditAmountTotal: 0,
      // filter: {},
      id: this.$route.params.id,
      works: [],
      note: "",
      value: "",
      Glossary: "",
      GlossaryList: [],
      memberTypeHide: false,
      btnShow: false,
      iframeshow: false,
      reportIdList: [],
      getReportId: [],
      dialogAddWork: false,
      dialogAddItem: false,
      currentAddItem: {
        memberId: "",
        cashTransferType: 1,
        // objectType: 2
        chooseRepayment: "",
        type: "",
        amount: "",
      },
      byData: [
        {
          label: "借方",
          value: 1,
        },
        {
          label: "貸方",
          value: 0,
        },
      ],
      // 將新增款項重製
      defaultAddItem: {
        type: "",
        amount: "",
        Summary: "",
        name: "",
        reviewRecoed: "",
        chooseRepayment: "",
        memberId: "",
        cashTransferType: 1,
        objectType: 2,
        date: "",
        meetRc: "",
      },
      currentIndex: 0,
      accountTitle: [],
      currentOtherItem: {},
      otherItem: [], //其他會計科目全部
      cashRecipientList: [],
      iouList: [],
      yearList: [],
      iouenumData: [],
      sixYearData: [],
      iouNumbers: "",
      counterWorkData: {},
      addMemberObj: {
        isFormal: "",
        chooseMember: {},
      },

      // 選擇社員
      options: [
        { id: 191, code: 3101, value: 0, label: "社員股金" },
        { id: 88, code: 2311, value: 1, label: "備轉金" },
        { code: "", value: 2, label: "還款" },

        { code: "", value: 6, label: "協議前欠" },
        { code: "", value: 3, label: "代辦互助基金" },
        { code: "", value: 4, label: "六年平儲" },
        { code: "", value: 7, label: "社員年費", type: 1 },
        { code: "", value: 5, label: "其他會計科目" },
      ],
      originType: [
        { id: 191, code: 3101, value: 0, label: "社員股金" },
        { id: 88, code: 2311, value: 1, label: "備轉金" },
        { code: "", value: 2, label: "還款" },
        { code: "", value: 8, label: "呆帳轉銷" },
        { code: "", value: 6, label: "協議前欠" },
        { code: "", value: 3, label: "代辦互助基金" },
        { code: "", value: 4, label: "六年平儲" },
        { code: "", value: 7, label: "社員年費", type: 1 },
        { code: "", value: 5, label: "其他會計科目" },
      ],
      loanModal: false,
      accountTitleEnum: [
        {},
        {},
        {
          code: "",
          name: "代辦互助基金",
        },
        {
          code: "",
          name: "六年平儲",
        },
        {
          code: "",
          name: "其他會計科目",
          options: [],
        },
      ],
      formType: [
        {
          label: "社員帳號",
          key: "chooseMember",
          type: "chooseMember",
          isclear: false,
          vif: true,
          filter: this.memberFilter,
        },
      ],
      type: this.$route.query.type, // manual手動 repayment還款相關
      send: false,
      invoice: {},
      rules: {
        name: [
          {
            required: true,
            message: "請輸入方案名稱",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "請輸入方案代碼",
            trigger: "blur",
          },
        ],
      },
      // 列印
      dialogPrint: false,
      currentPrint: {},
      base64: [],
    };
  },
  created() {
    this.getData();
    this.meetrc();
    this.getAccountData();
    this.setYearList();
    this.getGlossary();
  },
  mounted() {},
  computed: {
    tranferData() {
      return this.works.map((item) => {
        if (item.by == 1) {
          const newItem = {
            ...item,
            debitAmount: item.amount.toString().replace(/,/g, ""),
            amount: item.amount.toString().replace(/,/g, ""),
            dcType: item.by,
          };
          return newItem;
        } else {
          const newItem = {
            ...item,
            creditAmount: item.amount.toString().replace(/,/g, ""),
            amount: item.amount.toString().replace(/,/g, ""),
            dcType: item.by,
            debitAmount: 0,
          };
          return newItem;
        }
      });
    },
  },
  watch: {
    works: {
      handler(key) {
        this.debitAmountTotal = 0;
        this.creditAmountTotal = 0;
        this.works.forEach((item) => {
          let amount =
            typeof item.amount === "string"
              ? parseInt(this.$removeComma(item.amount))
              : item.amount;
          this.debitAmountTotal += item.by == 1 ? amount : 0;
          this.creditAmountTotal += item.by == 0 ? amount : 0;
        });
      },
      deep: true,
    },
    "currentAddItem.objectType": {
      handler(key) {
        this.currentAddItem.type = "";
        this.formType[0].filter = {
          isFormal: key,
        };
        if (key == 3) {
          if (this.currentAddItem.chooseRepayment !== "") {
            this.currentAddItem.chooseRepayment = "";
          }
          this.formType[0].vif = false;
          this.options = [{ code: "", value: 5, label: "其他會計科目" }];
        } else {
          if (this.currentAddItem.chooseRepayment !== "") {
            this.currentAddItem.chooseRepayment = "";
          }
          this.formType[0].vif = true;
          this.options = this.originType;
        }
      },
    },
    "currentAddItem.type": {
      handler(key) {
        this.currentAddItem.amount = "";
        this.selectYear = "";
      },
    },
    "addMemberObj.chooseMember": {
      handler(newKey) {
        this.iouList = [];
        this.iouenumData = {};
        this.currentAddItem.amount = "";
        this.currentAddItem.type = "";
      },
      deep: true,
    },
    dialogPrint: {
      handler(newKey) {
        if (!newKey) {
          this.$router.push({
            name: "all_payment_edit",
            params: { id: this.id },
          });
        }
      },
    },
  },
  methods: {
    getDate() {
      const url = API.coopVoucher + `?action=getNowTime`;
      const vm = this;
      const thenCB = (json) => {
        let Today = new Date(json.resultData);
        let Y = Today.getFullYear();
        let M = Today.getMonth() + 1;
        let D = Today.getDate();
        let A = `${Y}-${M < 10 ? "0" + M : M}-${D < 10 ? "0" + D : D}`;
        let mingoDate = `${Y - 1911}-${M < 10 ? "0" + M : M}-${
          D < 10 ? "0" + D : D
        }`;
        this.toDay = A;
        setTimeout(() => {
          $(`.min_go_date`).val(mingoDate);
          $(".min_go_date").datepicker({
            changeYear: true,
            changeMonth: true,
            currentText: "今天",
            dateFormat: "Rmmdd",
            showButtonPanel: true,
            yearRange: "1912:c+10",
            onSelect(data) {
              let key = $(this)[0].className.split(" ")[2];

              if (data) {
                this.toDay =
                  parseInt(data.split("-")[0]) + 1911 + "-" + data.slice(4);
              }
            },
          });
        }, 10);
      };

      this.mAxiosGet(url, thenCB);
    },
    recalculateVoucher() {
      let dateArray = $(`.min_go_date`).val().split(" ")[0].split("-");
      let searchDate = `${parseInt(dateArray[0]) + 1911}-${dateArray[1]}-${
        dateArray[2]
      }`;
      this.works = [];
      const url =
        API.coopVoucher +
        `?id=0&invoiceId=${this.$route.params.id}&baseDate=${searchDate}`;
      const thenCB = (json) => {
        this.parseVoucherDetail(json.resultData.enumData.invoiceVoucherDetail);
        this.parseVoucherDetail(
          json.resultData.enumData.iouVoucherDetail,
          false
        );

        if (json.resultData.enumData.invoice !== undefined) {
          this.invoice = json.resultData.enumData.invoice;
        }
      };
      this.mAxiosGet(url, thenCB);
    },
    meetrc() {
      let params = {
        page: { limit: 99999 },
      };
      let url = API.meetingRcd;
      this.$http.get(url, { params }).then((res) => {
        this.meetRc = res.data.resultData.data.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
      });
    },
    getData() {
      const url = API.coopVoucher + `?id=0&invoiceId=${this.$route.params.id}`;
      const thenCB = (json) => {
        this.parseVoucherDetail(json.resultData.enumData.invoiceVoucherDetail);
        this.parseVoucherDetail(
          json.resultData.enumData.iouVoucherDetail,
          true
        );

        if (json.resultData.enumData.invoice !== undefined) {
          this.invoice = json.resultData.enumData.invoice;
        }
        this.getDate();
      };
      this.mAxiosGet(url, thenCB);
    },
    parseVoucherDetail(voucherDetails, editAble = true) {
      if (voucherDetails != undefined && voucherDetails != null) {
        voucherDetails.forEach((item) => {
          if (item.debitAmount + item.creditAmount !== 0) {
            // 判斷是否為手續費科目（4104）
            const isCommissionFee = item.accountTitleCode === "4104";
            
            let newItem = {
              ...item,
              memberAccount: `${item.memberAccount || ""}`,
              memberName: `${item.memberName || ""}`,
              amount: item.dcType == 1 ? item.debitAmount : item.creditAmount,
              by: item.dcType,
              show: item.loanIouNumber,
              Summary: this.getSummery(item),
              removeable: false,
              disabled: !editAble,
              changeDc: isCommissionFee ? true : false, // 手續費科目可以切換借貸方
            };

            this.works.push(newItem);
          }
        });
      }
    },
    getSummery(item) {
      // 優先使用後端傳來的 summary
      if (item.summary && item.summary !== "") {
        return item.summary;
      }
      // 如果後端沒有 summary，則自動生成
      if (item.loanIouNumber && item.loanIouNumber !== "") {
        return `借據號:${item.loanIouNumber}`;
      } else if (
        item.insPlanApplyNumberShow &&
        item.insPlanApplyNumberShow !== ""
      ) {
        return `安基代辦申請單號:${item.insPlanApplyNumberShow}`;
      }
      return "";
    },
    handleList(arr) {
      arr.map((item) => {
        item.accountTitleCode = item.accountTitle.code;
        item.accountTitleId = item.accountTitle.id;
        item.accountTitleName = item.accountTitle.name;

        return item;
      });
      return arr;
    },
    goMember() {
      if (this.recordToEdit.memberId) {
        const { href } = this.$router.resolve({
          name: "member_edit",
          params: { id: this.recordToEdit.memberId },
        });
        window.open(href, "_blank", "toolbar=yes, width=1300, height=900");
      }
    },
    setYearList() {
      let date = new Date();
      let Y = date.getFullYear();
      let YearArr = [];
      for (let i = 0; i < 3; i++) {
        let yearObj = {
          label: String(Y - i - 1911),
          value: Number(Y - i),
        };
        YearArr.push(yearObj);
      }
      this.yearList = YearArr;
    },

    print(row) {
      // 因 data 內又多包一層 main 故不能直接使用 id 須透過 row
      const url = API.coopVoucher;
      // get 參數
      const params = {
        action: "print",
        id: row.main.id,
      };

      this.mDownloadFile(url, false, "", params);
    },
    getAmount() {
      if (this.currentAddItem.type === 3) {
        this.currentAddItem.amount = this.$addcomma(
          this.currentAddItem.chooseRepayment.noPayAmount
        );
        this.currentAddItem.name =
          this.currentAddItem.chooseRepayment.insPlanMainName;
        this.iouList.filter((item) => {
          if (this.currentAddItem.chooseRepayment.id == item.id) {
            this.currentOtherItem = item;
          }
        });
      }
      if (this.currentAddItem.type === 4) {
        this.currentAddItem.amount = this.iouList[0].value;
        // this.currentAddItem.name = this.currentAddItem.chooseRepayment.insPlanMainName;
      } else if (this.currentAddItem.type === 2) {
        let form = new FormData();
        // this.currentAddItem.amount = this.currentAddItem.chooseRepayment.noPayAmount;
        // this.currentAddItem.name = this.currentAddItem.chooseRepayment.insPlanMainName;
        let urlSelect = API.coopLoanIou + `?action=voucherGetCalByDate`;
        form.append("iouNumber", this.currentAddItem.chooseRepayment);
        form.append("baseDate", this.currentAddItem.date);
        let thenCB = (json) => {
          this.currentAddItem.iouObj = json.resultData;
        };
        this.mAxiosPost(urlSelect, form, thenCB);
      } else if (this.currentAddItem.type === 5) {
        this.otherItem.filter((item) => {
          if (item.id == this.currentAddItem.chooseRepayment) {
            this.currentOtherItem = item;
          }
        });
      } else if (this.currentAddItem.type === 7) {
        let urlSelect =
          API.member +
          `?action=ActionGetMemberAnnualCost&id=${this.addMemberObj.chooseMember.id}&year=${this.selectYear}`;
        let thenCB = (json) => {
          this.currentAddItem.amount = this.$addcomma(json.resultData.data);
          this.currentAddItem.iouObj =
            json.resultData.enumData.annualAccountTitle;
        };
        this.mAxiosGet(urlSelect, thenCB);
      } else if (this.currentAddItem.type === 6) {
        let url =
          API.coopLoanIou +
          `?action=getAgrBackpay&coopLoanIouId=${this.currentAddItem.chooseRepayment}&baseDate=${this.currentAddItem.date}`;
        let thenCB = (json) => {
          this.currentAddItem.iouObj = json.resultData.data;
          this.iouenumData = json.resultData.enumData;

          let sumAmount = 0;

          Object.keys(json.resultData.data).forEach((_key) => {
            let calculateObject = json.resultData.data[_key];
            if (calculateObject.length > 0) {
              sumAmount +=
                calculateObject[calculateObject.length - 1].backPayPriceTotal ||
                0;
            }
          });

          this.currentAddItem.amount = sumAmount;
        };
        this.mAxiosGet(url, thenCB);
      } else if (this.currentAddItem.type === 8) {
        this.iouList.forEach((item) => {
          if (item.id == this.currentAddItem.chooseRepayment) {
            this.currentAddItem.amount = item.iouPrincipalDealAmount;
            this.currentAddItem.currentOtherItem = item;
            this.currentAddItem.by = 0;
          }
        });
      }
    },
    getMemberById(id) {
      const url = API.member + `?id=${id}&action=ActionGetMemberSimple`;
      return this.$http.get(url);
    },
    chooseType() {
      let urlSelect = "";
      if (this.currentAddItem.chooseRepayment !== "") {
        this.currentAddItem.chooseRepayment = "";
      }
      let thenCB = null;
      switch (this.currentAddItem.type) {
        // 撈取股金列表
        case 0:
          urlSelect = "";
          this.inputDsabled = false;
          break;
        // 撈取備轉金列表
        case 1:
          urlSelect = "";
          this.inputDsabled = false;
          break;
        // 撈取借據列表
        case 2:
          urlSelect =
            API.coopLoanIou +
            `?action=getListByMember&memberId=${this.addMemberObj.chooseMember.id}`; //${this.works[this.currentIndex].id}
          thenCB = (json) => {
            this.iouList = json.resultData;
          };
          this.mAxiosGet(urlSelect, thenCB);
          this.inputDsabled = false;
          break;
        // 撈取代辦互助基金列表
        case 3:
          urlSelect =
            API.coopInsPlanMember +
            `?action=getInsPlanByMember&memberId=${this.addMemberObj.chooseMember.id}`;
          thenCB = (json) => {
            this.iouList = json.resultData.map((item) => {
              return {
                ...item,
                value: item.insPlanMainCode,
                label: item.insPlanMainName,
                noPayAmount: item.diffAmount,
                insPlanApplyNumber: item.insPlanMainCode,
                insPlanApplyId: item.insPlanMemberApplyId,
                accountTitleId: item.colAccountTitle.id,
                accountTitleCode: item.colAccountTitle.code,
                insPlanMemberApplyId: item.insPlanMemberApplyId,
              };
            });
          };
          this.mAxiosGet(urlSelect, thenCB);
          this.inputDsabled = true;
          break;
        // 撈取六年平儲列表
        case 4:
          urlSelect =
            API.coopInsSavingApply +
            `?action=getMemberNotEnd&memberId=${this.addMemberObj.chooseMember.id}`;
          thenCB = (json) => {
            this.sixYearData = json.resultData;
            this.iouList = json.resultData.data.map((item) => {
              return {
                label: item.insSavingCode,
                value: item.advAmount + item.advFeeAmount,
                accountTitleSixYear: {
                  label: `${json.resultData.enumData.accountTitleSixYear.code} ${json.resultData.enumData.accountTitleSixYear.name}`,
                  value: json.resultData.enumData.accountTitleSixYear.id,
                  amount: item.advAmount,
                },
                accountTitleSixYearInterest: {
                  label: `${json.resultData.enumData.accountTitleSixYearInterest.code} ${json.resultData.enumData.accountTitleSixYearInterest.name}`,
                  value:
                    json.resultData.enumData.accountTitleSixYearInterest.id,
                  amount: item.advFeeAmount,
                },
              };
            });
          };
          this.mAxiosGet(urlSelect, thenCB);
          this.inputDsabled = false;
          break;
        // 撈取其他列表
        case 5:
          urlSelect = API.coopAccountTitle + `?action=getByManualReceipt`;
          this.$http.get(urlSelect).then((res) => {
            this.otherItem = res.data.resultData;
            this.iouList = res.data.resultData.map((item) => {
              return {
                label: `${item.code} ${item.name}`,
                value: item.id,
                code: item.code,
                name: item.name,
              };
            });
          });
          this.inputDsabled = false;
          break;
        // 撈取協議前欠
        case 6:
          urlSelect =
            API.coopLoanIou +
            `?action=getMemberAgrBackpayNotPay&memberId=${this.addMemberObj.chooseMember.id}`;
          thenCB = (json) => {
            this.iouList = json.resultData.data.iouList =
              json.resultData.data.map((iouAgr) => {
                return {
                  label: iouAgr.coopLoanIouNumber,
                  value: iouAgr.coopLoanIouId,
                };
              });
          };
          this.mAxiosGet(urlSelect, thenCB);

          this.inputDsabled = true;
          break;
        case 7:
          this.inputDsabled = true;
          break;
        case 8:
          urlSelect =
            API.coopLoanIouDead +
            `?action=getMemberIouDeadList&memberId=${this.addMemberObj.chooseMember.id}`;
          thenCB = (json) => {
            this.iouenumData = json.resultData.enumData;
            this.iouList = json.resultData.data.map((item) => {
              return {
                ...item,
                label: item.iouNumber,
                value: item.id,
              };
            });
          };
          this.mAxiosGet(urlSelect, thenCB);

          break;
        default:
          urlSelect = "";
      }
    },
    getAccountData() {
      const url = API.coopAccountTitle;
      let params = {
        page: { limit: 99999 },
      };
      this.$http
        .get(url, { params })
        .then((res) => {
          this.accountTitle = res.data.resultData.data.map((item) => {
            return {
              label: `${item.code} ${item.name}`,
              value: item.id,
              createVoucherNeedReview: item.createVoucherNeedReview || "",
              code: item.code,
              name: item.name,
            };
          });
          this.accountTitleEnum[0] = res.data.resultData.data.filter((item) => {
            if (item.code == "3101") {
              item.value = item.id;
              return item;
            }
          });
          this.accountTitleEnum[1] = res.data.resultData.data.filter((item) => {
            if (item.code == "2311") {
              item.value = item.id;
              return item;
            }
          });
        })
        .catch((error) => {
          this.getErrorHandler(error);
        });
    },
    meetrc() {
      let params = {
        page: { limit: 99999 },
      };
      let url = API.meetingRcd;
      this.$http.get(url, { params }).then((res) => {
        this.meetRc = res.data.resultData.data.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
      });
    },
    go(name) {
      this.$router.push({ name: name });
    },
    back() {
      this.$router.push({
        name: "all_payment",
      });
    },
    getAccountTitleItem() {
      let url = API.coopAccountTitle + `?action=getCashReceiptItem`;
      this.$http.get(url).then((res) => {});
    },
    getDateValue() {
      let dateArray = $(`.min_go_date`).val().split(" ")[0].split("-");
      let transferDate = `${parseInt(dateArray[0]) + 1911}-${dateArray[1]}-${
        dateArray[2]
      }`;

      this.currentAddItem.date = transferDate;
    },
    openAddItem() {
      const vm = this;
      this.getDateValue();
      if (!this.currentAddItem.date) {
        this.$message.closeAll();
        this.$message({
          type: "warning",
          message: "請先選擇日期",
        });
        return;
      } else {
        this.currentAddItem.type = "";
        this.currentAddItem.amount = "";
        this.selectYear = "";
        this.inputDsabled = false;
        this.dialogAddItem = true;
      }
      // else if (this.currentAddItem.objectType == 0) {
      //     this.formType[0].vif = true;
      //     this.dialogAddItem = true;
      // } else if (this.currentAddItem.objectType == 1) {
      //     this.formType[0].vif = true;
      //     this.dialogAddItem = true;
      // } else if (this.currentAddItem.objectType == 3) {
      //     this.formType[0].vif = false;
      //     this.dialogAddItem = true;
      // } else {
      //     this.$message.closeAll();
      //     this.$message({
      //         type: "warning",
      //         message: "請先選擇社員類型"
      //     });
      // }
    },
    saveAddItem() {
      if (this.currentAddItem.type == 3) {
        const newObj = JSON.parse(JSON.stringify(this.currentAddItem));
        newObj.type = this.currentAddItem.type;
        newObj.memberId = this.addMemberObj.chooseMember.id;
        newObj.memberAccount = this.addMemberObj.chooseMember.account;
        newObj.memberName = this.addMemberObj.chooseMember.name;
        newObj.amount = this.currentAddItem.amount;
        newObj.objectType = this.currentAddItem.objectType;
        newObj.by = this.currentAddItem.by;
        newObj.Summary = this.currentAddItem.chooseRepayment.insPlanMainName;
        newObj.date = this.currentAddItem.date;
        newObj.accountTitleCode = this.currentOtherItem.accountTitleCode;
        newObj.accountTitleName = this.filterAccountTitle(
          this.currentOtherItem.accountTitleId
        );
        newObj.accountTitleId = this.currentOtherItem.accountTitleId;
        newObj.insPlanApplyNumberShow =
          this.currentAddItem.chooseRepayment.insPlanApplyNumber;
        newObj.insPlanApplyNumber =
          this.currentAddItem.chooseRepayment.insPlanMemberApplyId;
        newObj.debitNumber = this.currentAddItem.chooseRepayment;
        newObj.createVoucherNeedReview =
          this.currentOtherItem.createVoucherNeedReview || "";
        newObj.meetRc = this.currentAddItem.meetRecord || "";
        newObj.disabled = true;
        newObj.removeable = true;
        this.works.push(newObj);
        this.currentAddItem = {
          type: "",
          amount: "",
          Summary: "",
          name: "",
          reviewRecoed: "",
          chooseRepayment: "",
          memberId: "",
          cashTransferType: 1,
          objectType: 2,
          meetRc: "",
          date:
            this.currentAddItem.date !== undefined
              ? this.currentAddItem.date
              : "",
        };
        this.dialogAddItem = false;
      } else if (this.currentAddItem.type == 2) {
        if (this.currentAddItem.amount && this.currentAddItem.chooseRepayment) {
          const ioupayBackLoanPrice =
            this.currentAddItem.iouObj.payBackLoanPrice;
          const ioupayBackInterest = this.currentAddItem.iouObj.payBackInterest;
          const ioupayBackBreakPrice =
            this.currentAddItem.iouObj.payBackBreakPrice;
          const accountTitle = this.currentAddItem.iouObj.accountTitle;
          const thisAmout = this.$removeComma(this.currentAddItem.amount);
          let capitalObj = {
            name: `${accountTitle.capitalAccountTitle.code} ${accountTitle.capitalAccountTitle.name}`,
            date: this.currentAddItem.date,
            objectType: this.currentAddItem.objectType,
            accountTitleId: accountTitle.capitalAccountTitle.id,
            memberId: this.addMemberObj.chooseMember.id,
            memberAccount: this.addMemberObj.chooseMember.account,
            memberName: this.addMemberObj.chooseMember.name,
            accountTitleCode: accountTitle.capitalAccountTitle.code,
            accountTitleName: accountTitle.capitalAccountTitle.name,
            type: "還款",
            show: `金額: ${ioupayBackLoanPrice}, 借據號: ${this.currentAddItem.chooseRepayment}`,
            loanIouNumber: this.currentAddItem.chooseRepayment,
            // ioutObj: {
            //     amount: this.currentAddItem.iouObj.payBackPrice
            // },
            amount: this.$addcomma(
              thisAmout - (ioupayBackBreakPrice + ioupayBackInterest) > 0
                ? thisAmout -
                    parseInt(
                      +Number(ioupayBackInterest) + Number(ioupayBackBreakPrice)
                    )
                : thisAmout - (ioupayBackBreakPrice + ioupayBackInterest) < 0
                ? "0"
                : thisAmout - (ioupayBackBreakPrice + ioupayBackInterest)
            ),
            // addamount: this.currentAddItem.amount,
            by: this.currentAddItem.by,
            Summary: `借據號:${this.currentAddItem.chooseRepayment}`,
            note: this.currentAddItem.Summary || "",
            createVoucherNeedReview:
              this.currentAddItem.iouObj.accountTitle.capitalAccountTitle
                .createVoucherNeedReview || "",
            meetRc: this.currentAddItem.meetRecord || "",
            removeable: true,
          };
          let interestObj = {
            name: `${accountTitle.interestAccountTitleId.code} ${accountTitle.interestAccountTitleId.name}`,
            date: this.currentAddItem.date,
            objectType: this.currentAddItem.objectType,
            accountTitleId: accountTitle.interestAccountTitleId.id,
            memberId: this.addMemberObj.chooseMember.id,
            memberAccount: this.addMemberObj.chooseMember.account,
            memberName: this.addMemberObj.chooseMember.name,
            accountTitleCode: accountTitle.interestAccountTitleId.code,
            accountTitleName: accountTitle.interestAccountTitleId.name,
            show: `金額: ${ioupayBackInterest}, 借據號: ${this.currentAddItem.chooseRepayment}`,
            loanIouNumber: this.currentAddItem.chooseRepayment,
            type: "還款",
            amount: this.$addcomma(
              thisAmout - (ioupayBackBreakPrice + ioupayBackInterest) > 0
                ? ioupayBackInterest
                : thisAmout - ioupayBackBreakPrice < 0
                ? "0"
                : thisAmout - ioupayBackBreakPrice
            ),
            by: this.currentAddItem.by,
            Summary: `借據號:${this.currentAddItem.chooseRepayment}`,
            note: this.currentAddItem.Summary || "",
            createVoucherNeedReview:
              this.currentAddItem.iouObj.accountTitle.interestAccountTitleId
                .createVoucherNeedReview || "",
            meetRc: this.currentAddItem.meetRecord || "",
            removeable: true,
          };
          let ldObj = {
            name: `${accountTitle.ldAccountTitleId.code} ${accountTitle.ldAccountTitleId.name}`,
            date: this.currentAddItem.date,
            objectType: this.currentAddItem.objectType,
            memberId: this.addMemberObj.chooseMember.id,
            memberAccount: this.addMemberObj.chooseMember.account,
            memberName: this.addMemberObj.chooseMember.name,
            accountTitleId: accountTitle.ldAccountTitleId.id,
            accountTitleCode: accountTitle.ldAccountTitleId.code,
            accountTitleName: accountTitle.ldAccountTitleId.name,
            show: `金額: ${ioupayBackBreakPrice}, 借據號: ${this.currentAddItem.chooseRepayment}`,
            loanIouNumber: this.currentAddItem.chooseRepayment,
            type: "還款",
            amount: this.$addcomma(
              thisAmout - ioupayBackBreakPrice > 0
                ? ioupayBackBreakPrice
                : thisAmout
            ),
            by: this.currentAddItem.by,
            Summary: `借據號:${this.currentAddItem.chooseRepayment}`,
            note: this.currentAddItem.Summary || "",
            createVoucherNeedReview:
              this.currentAddItem.iouObj.accountTitle.ldAccountTitleId
                .createVoucherNeedReview || "",
            meetRc: this.currentAddItem.meetRecord || "",
            removeable: true,
          };

          // this.works[this.currentIndex].content.push(capitalObj);
          // this.works[this.currentIndex].content.push(interestObj);
          // this.works[this.currentIndex].content.push(ldObj);

          this.works.push(capitalObj);
          this.works.push(interestObj);
          this.works.push(ldObj);
          this.currentAddItem = {
            type: "",
            amount: "",
            Summary: "",
            name: "",
            reviewRecoed: "",
            chooseRepayment: "",
            memberId: "",
            cashTransferType: 1,
            objectType: 2,
            meetRc: "",
            date:
              this.currentAddItem.date !== undefined
                ? this.currentAddItem.date
                : "",
          };
          this.dialogAddItem = false;
        } else {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "請選擇方案與金額",
          });
        }
        // this.removeMember();
      } else if (this.currentAddItem.type === 4) {
        if (this.currentAddItem.amount) {
          const newObj = JSON.parse(JSON.stringify(this.currentAddItem));
          let accountTitleSixYear = {
            name: `${this.sixYearData.enumData.accountTitleSixYear.code} ${this.sixYearData.enumData.accountTitleSixYear.name}`,
            accountTitleId: this.sixYearData.enumData.accountTitleSixYear.id,
            accountTitleCode:
              this.sixYearData.enumData.accountTitleSixYear.code,
            accountTitleName:
              this.sixYearData.enumData.accountTitleSixYear.name,
            type: this.currentAddItem.type,
            Summary: this.currentAddItem.Summary || "",
            by: this.currentAddItem.by,
            amount: this.$addcomma(this.sixYearData.data[0].advAmount),
            addamount: this.sixYearData.data[0].advAmount,
            insSavingCode: this.sixYearData.data[0].insSavingCode,
            objectType: this.currentAddItem.objectType,
            date: this.currentAddItem.date,
            cashTransferType: this.currentAddItem.cashTransferType,
            memberId: this.addMemberObj.chooseMember.id,
            memberAccount: this.addMemberObj.chooseMember.account,
            memberName: this.addMemberObj.chooseMember.name,
            meetRc: this.currentAddItem.meetRecord || "",
            removeable: true,
          };
          let accountTitleSixYearInterest = {
            name: `${this.sixYearData.enumData.accountTitleSixYearInterest.code} ${this.sixYearData.enumData.accountTitleSixYearInterest.name}`,
            accountTitleId:
              this.sixYearData.enumData.accountTitleSixYearInterest.id,
            accountTitleCode:
              this.sixYearData.enumData.accountTitleSixYearInterest.code,
            accountTitleName:
              this.sixYearData.enumData.accountTitleSixYearInterest.name,
            type: this.currentAddItem.type,
            Summary: this.currentAddItem.Summary || "",
            by: this.currentAddItem.by,
            amount: this.$addcomma(this.sixYearData.data[0].advFeeAmount),
            addamount: this.sixYearData.data[0].advFeeAmount,
            insSavingCode: this.sixYearData.data[0].insSavingCode,
            objectType: this.currentAddItem.objectType,
            date: this.currentAddItem.date,
            cashTransferType: this.currentAddItem.cashTransferType,
            memberId: this.addMemberObj.chooseMember.id,
            memberAccount: this.addMemberObj.chooseMember.account,
            memberName: this.addMemberObj.chooseMember.name,
            meetRc: this.currentAddItem.meetRecord || "",
            removeable: true,
          };
          this.works.push(accountTitleSixYear);
          this.works.push(accountTitleSixYearInterest);
          this.currentAddItem = {
            type: "",
            amount: "",
            Summary: "",
            name: "",
            reviewRecoed: "",
            chooseRepayment: "",
            memberId: "",
            cashTransferType: 1,
            objectType: 2,
            meetRc: "",
            date:
              this.currentAddItem.date !== undefined
                ? this.currentAddItem.date
                : "",
          };
          this.dialogAddItem = false;
        }
      } else if (this.currentAddItem.type == 5) {
        const newObj = JSON.parse(JSON.stringify(this.currentAddItem));

        if (
          !this.currentAddItem.amount ||
          !this.currentAddItem.chooseRepayment
        ) {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "請選擇方案與金額",
          });
          return;
        }

        if (this.currentAddItem.objectType !== 3) {
          newObj.memberId = this.addMemberObj.chooseMember.id;
          newObj.memberAccount = this.addMemberObj.chooseMember.account;
          newObj.memberName = this.addMemberObj.chooseMember.name;
          newObj.type = this.currentAddItem.type;
        }
        // newObj.addamount = this.currentAddItem.amount;
        newObj.amount = this.$addcomma(this.currentAddItem.amount);
        newObj.objectType = this.currentAddItem.objectType;
        newObj.by = this.currentAddItem.by;
        newObj.Summary = this.currentAddItem.Summary;
        newObj.date = this.currentAddItem.date;
        newObj.accountTitleCode = this.currentOtherItem.code;
        newObj.accountTitleName = this.currentOtherItem.name;
        newObj.accountTitleId = this.currentOtherItem.id;
        newObj.debitNumber = this.currentAddItem.chooseRepayment;
        newObj.createVoucherNeedReview =
          this.currentOtherItem.createVoucherNeedReview || "";
        newObj.meetRc = this.currentAddItem.meetRecord || "";
        newObj.removeable = true;
        this.works.push(newObj);
        this.currentAddItem = {
          type: "",
          amount: "",
          Summary: "",
          name: "",
          reviewRecoed: "",
          chooseRepayment: "",
          memberId: "",
          cashTransferType: 1,
          objectType: 2,
          meetRc: "",
          date:
            this.currentAddItem.date !== undefined
              ? this.currentAddItem.date
              : "",
        };
        this.dialogAddItem = false;
      }

      // else if (this.currentAddItem.type === 3) {
      // 	if (
      // 		this.currentAddItem.amount &&
      // 		this.currentAddItem.chooseRepayment
      // 	) {
      // 		const newObj = JSON.parse(
      // 			JSON.stringify(this.currentAddItem)
      // 		);
      // 		newObj.memberId = this.addMemberObj.chooseMember.id;
      // 		newObj.memberAccount = this.addMemberObj.chooseMember.account;
      // 		newObj.memberName = this.addMemberObj.chooseMember.name;
      // 		newObj.type = this.currentAddItem.type;
      // 		// newObj.addamount = this.currentAddItem.amount;
      // 		newObj.amount = this.$addcomma(
      // 			this.currentAddItem.amount
      // 		);
      // 		newObj.objectType = this.currentAddItem.objectType;
      // 		newObj.by = this.currentAddItem.by;
      // 		newObj.Summary = this.currentAddItem.insPlanMainName;
      // 		newObj.date = this.currentAddItem.date;
      // 		newObj.insPlanApplyNumber = this.currentAddItem.chooseRepayment.insPlanApplyNumber;
      // 		newObj.accountTitleId = this.currentAddItem.chooseRepayment.accountTitleId;
      // 		newObj.accountTitleCode = this.currentAddItem.chooseRepayment.accountTitleCode;
      // 		newObj.addamount = this.currentAddItem.amount;
      // 		newObj.meetRc = this.currentAddItem.meetRecord || "";
      // 		newObj.disabled = true;
      // 		this.works.push(newObj);
      // 		this.currentAddItem = {
      // 			type: "",
      // 			amount: "",
      // 			Summary: "",
      // 			name: "",
      // 			reviewRecoed: "",
      // 			chooseRepayment: "",
      // 			memberId: "",
      // 			cashTransferType: 1,
      // 			objectType: 2,
      // 			meetRc: "",
      // 			date:
      // 				this.currentAddItem.date !== undefined
      // 					? this.currentAddItem.date
      // 					: ""
      // 		};
      // 		this.dialogAddItem = false;
      // 	}
      // 	else {
      // 		this.$message.closeAll();
      // 		this.$message({
      // 			type: "warning",
      // 			message: "請輸入金額"
      // 		});
      // 	}
      // }
      else if (this.currentAddItem.type == 6) {
        if (this.currentAddItem.amount) {
          let accountTitleIou = this.iouenumData.accountTitle;
          let iouBackPayPrice = this.currentAddItem.iouObj;
          let iouObject = this.iouenumData.iou;
          let agrObject = this.iouenumData.agr;
          let accountTitlePriceMap = [
            {
              accountTitleName: "agrBackPayAccountTitle",
              objectName: "otherBackPay",
            },
            {
              accountTitleName: "interestAccountTitleId",
              objectName: "interestBackPay",
            },
            {
              accountTitleName: "ldAccountTitleId",
              objectName: "defBackPay",
            },
          ];
          accountTitlePriceMap.forEach((accountTitleMap) => {
            let accountTitleCurrent =
              accountTitleIou[accountTitleMap.accountTitleName];
            let priceItem = iouBackPayPrice[accountTitleMap.objectName];
            if (priceItem.length > 0) {
              let finalPriceTotal =
                priceItem[priceItem.length - 1].backPayPriceTotal;

              let accountTitleObject = {
                name: `${accountTitleCurrent.code} ${accountTitleCurrent.name}`,
                accountTitleCode: accountTitleCurrent.code,
                accountTitleName: accountTitleCurrent.name,
                accountTitleId: accountTitleCurrent.id,
                amount: this.$addcomma(finalPriceTotal),
                Summary: `借據號 ${iouObject.iouNumber} 協議 ${agrObject.agreementCode} 前欠金額`,
                note: `借據號 ${iouObject.iouNumber} 協議 ${agrObject.agreementCode} 前欠金額`,
                show: iouObject.iouNumber,
                loanIouNumber: iouObject.iouNumber,
                loanIouAgrCode: agrObject.agreementCode,
                display: true,
                objectType: this.currentAddItem.objectType,
                date: this.currentAddItem.date,
                memberId: this.addMemberObj.chooseMember.id,
                memberAccount: this.addMemberObj.chooseMember.account,
                memberAccounTitle: this.addMemberObj.chooseMember.account,
                memberName: this.addMemberObj.chooseMember.name,
                by: this.currentAddItem.by,
                type: this.currentAddItem.type,
                meetRc: this.currentAddItem.meetRecord || "",
                removeable: true,
              };
              if (finalPriceTotal > 0) {
                this.works.push(accountTitleObject);
              }
            }
          });

          this.currentAddItem = {
            type: "",
            amount: "",
            Summary: "",
            name: "",
            reviewRecoed: "",
            chooseRepayment: "",
            memberId: "",
            cashTransferType: 1,
            objectType: 2,
            meetRc: "",
            date:
              this.currentAddItem.date !== undefined
                ? this.currentAddItem.date
                : "",
          };
          this.dialogAddItem = false;
        } else {
          this.$message.closeAll();
          this.$message({
            type: "warning",
            message: "請輸入金額",
          });
        }
      } else if (this.currentAddItem.type == 7) {
        const newObj = JSON.parse(JSON.stringify(this.currentAddItem));
        newObj.memberId = this.addMemberObj.chooseMember.id;
        newObj.memberAccount = this.addMemberObj.chooseMember.account;
        newObj.memberAccounTitle = this.addMemberObj.chooseMember.account;
        newObj.memberName = this.addMemberObj.chooseMember.name;
        newObj.type = this.currentAddItem.type;
        newObj.amount = this.currentAddItem.amount;
        newObj.objectType = this.currentAddItem.objectType;
        newObj.by = this.currentAddItem.by;
        newObj.Summary = this.currentAddItem.Summary || "";
        newObj.date = this.currentAddItem.date;
        newObj.accountTitleCode = this.currentAddItem.iouObj.code;
        newObj.accountTitleName = this.currentAddItem.iouObj.name;
        newObj.accountTitleId = this.currentAddItem.iouObj.id;
        newObj.annualCostYear = this.selectYear;
        newObj.disabled = true;
        newObj.removeable = true;
        this.works.push(newObj);
        this.currentAddItem = {
          type: "",
          amount: "",
          Summary: "",
          name: "",
          reviewRecoed: "",
          chooseRepayment: "",
          memberId: "",
          cashTransferType: 1,
          objectType: this.currentAddItem.objectType
            ? this.currentAddItem.objectType
            : this.currentAddItem.objectType == 0
            ? 0
            : "",
          meetRc: "",
          date:
            this.currentAddItem.date !== undefined
              ? this.currentAddItem.date
              : "",
        };
        this.dialogAddItem = false;
      } else if (this.currentAddItem.type == 8) {
        let obj = this.currentAddItem.currentOtherItem;
        let CreditObj = this.iouenumData.accountTitlePrincipalCredit;
        let GuaranteeObj = this.iouenumData.accountTitlePrincipalGuarantee;
        let pay = this.iouenumData.accountTitlePay;

        let LoanIouDeadObj = {
          memberId: this.addMemberObj.chooseMember.id,
          memberAccount: this.addMemberObj.chooseMember.account,
          memberAccounTitle: this.addMemberObj.chooseMember.account,
          memberName: this.addMemberObj.chooseMember.name,
          name: `${obj.loanType == 1 ? CreditObj.code : GuaranteeObj.code} ${
            obj.loanType == 1 ? CreditObj.name : GuaranteeObj.name
          }`,
          accountTitleId: obj.loanType == 1 ? CreditObj.id : GuaranteeObj.id,
          accountTitleCode:
            obj.loanType == 1 ? CreditObj.code : GuaranteeObj.code,
          accountTitleName:
            obj.loanType == 1 ? CreditObj.name : GuaranteeObj.name,
          type: this.currentAddItem.type,
          Summary:
            (this.currentAddItem.note || "") +
            `金額: ${this.$addcomma(obj.iouPrincipalDealAmount)}, 借據號: ${
              obj.iouNumber
            }`,
          loanIouNumber: obj.iouNumber,

          amount: this.$addcomma(obj.iouPrincipalDealAmount),
          addamount: this.$addcomma(obj.iouPrincipalDealAmount),
          note: `金額: ${this.$addcomma(
            obj.iouPrincipalDealAmount
          )}, 借據號: ${obj.iouNumber}`,
          show: `金額: ${this.$addcomma(
            obj.iouPrincipalDealAmount
          )}, 借據號: ${obj.iouNumber}`,
          objectType: this.currentAddItem.objectType,
          display: true,
          removeable: true,
          by: this.currentAddItem.by,
        };
        let LoanPayObj = {
          memberId: this.addMemberObj.chooseMember.id,
          memberAccount: this.addMemberObj.chooseMember.account,
          memberAccounTitle: this.addMemberObj.chooseMember.account,
          memberName: this.addMemberObj.chooseMember.name,
          name: `${pay.code} ${pay.name}`,
          accountTitleId: pay.id,
          accountTitleCode: pay.code,
          accountTitleName: pay.name,
          type: this.currentAddItem.type,
          Summary:
            (this.currentAddItem.note || "") +
            `金額: ${this.$addcomma(
              obj.iouDefNoPayAmount +
                obj.iouInterNoPayAmount +
                obj.iouLawNoPayAmount
            )}, 借據號: ${obj.iouNumber}`,
          loanIouNumber: this.currentAddItem.iouNumber,
          // chooseRepayment: "",
          amount: this.$addcomma(
            obj.iouDefNoPayAmount +
              obj.iouInterNoPayAmount +
              obj.iouLawNoPayAmount
          ),
          addamount: this.$addcomma(
            obj.iouDefNoPayAmount +
              obj.iouInterNoPayAmount +
              obj.iouLawNoPayAmount
          ),
          note: `金額: ${this.$addcomma(
            obj.iouDefNoPayAmount +
              obj.iouInterNoPayAmount +
              obj.iouLawNoPayAmount
          )}, 借據號: ${obj.iouNumber}`,
          show: `金額: ${this.$addcomma(
            obj.iouDefNoPayAmount +
              obj.iouInterNoPayAmount +
              obj.iouLawNoPayAmount
          )}, 借據號: ${obj.iouNumber}`,
          objectType: this.currentAddItem.objectType,
          display: true,
          removeable: true,
          by: this.currentAddItem.by,
        };

        this.works.push(LoanIouDeadObj);
        this.works.push(LoanPayObj);
        this.dialogAddItem = false;
      } else {
        const newObj = JSON.parse(JSON.stringify(this.currentAddItem));
        newObj.memberId = this.addMemberObj.chooseMember.id;
        newObj.memberAccount = this.addMemberObj.chooseMember.account;
        newObj.memberName = this.addMemberObj.chooseMember.name;
        newObj.type = this.currentAddItem.type;
        newObj.amount = this.$addcomma(this.currentAddItem.amount);
        // newObj.addamount = this.currentAddItem.amount;
        newObj.objectType = this.currentAddItem.objectType;
        newObj.by = this.currentAddItem.by;
        newObj.Summary = this.currentAddItem.Summary;
        newObj.date = this.currentAddItem.date;
        newObj.accountTitleCode =
          this.accountTitleEnum[this.currentAddItem.type][0].code;
        newObj.accountTitleName =
          this.accountTitleEnum[this.currentAddItem.type][0].name;
        newObj.accountTitleId =
          this.accountTitleEnum[this.currentAddItem.type][0].id;
        newObj.createVoucherNeedReview =
          this.accountTitleEnum[this.currentAddItem.type][0]
            .createVoucherNeedReview || "";
        newObj.meetRc = this.currentAddItem.meetRecord || "";
        newObj.removeable = true;
        this.works.push(newObj);
        this.currentAddItem = {
          type: "",
          amount: "",
          Summary: "",
          name: "",
          reviewRecoed: "",
          chooseRepayment: "",
          memberId: "",
          cashTransferType: 1,
          objectType: 2,
          meetRc: "",
          date:
            this.currentAddItem.date !== undefined
              ? this.currentAddItem.date
              : "",
        };
        this.dialogAddItem = false;
      }
    },
    removeItem(item, itemIndex) {
      this.works.splice(itemIndex, 1);
    },
    checkItem() {
      this.works.some((item) => {
        if (item.createVoucherNeedReview == 1) {
          this.isWait = true;
        }
      });
      this.getDateValue();
      this.submit();
    },
    submit() {
      const vm = this;
      let isSend = false;
      if (this.works.length == 0) {
        isSend = true;
        this.$message.closeAll();
        this.$message({
          type: "warning",
          message: "尚未開立傳票",
        });
      } else {
        isSend = this.works.some((item) => {
          if (item.amount == 0 || item.amount == "" || !item.amount) {
            this.$message.closeAll();
            this.$message({
              type: "warning",
              message: "請先確認開立的金額不能為零或不能為空",
            });
            return true;
          }
        });
      }
      this.isSendForm(isSend);
    },
    isSendForm(key) {
      if (key == false) {
        let url = API.coopVoucher + `?action=invoiceAppend`;

        let objKey = this.works.find((item) => {
          if (item.objectType && item.objectType >= 0) {
            return item;
          }
        });

        const form = new FormData();
        const thenCB = (json) => {
          this.$message.closeAll();
          this.$message({
            type: "success",
            message: "開立成功",
          });
          // this.$router.push({
          // 	name: "all_payment_summons_report",
          // 	params: {
          // 		id: json.resultData.main.id
          // 	}
          // });
          this.openDialog(json.resultData.main);
        };
        form.append("invoiceId", this.$route.params.id);
        form.append("memberId", this.works[0].memberId);
        form.append("tradeDate", this.currentAddItem.date);
        form.append("cashTransferType", 1);
        form.append(
          "objectType",
          objKey !== undefined ? objKey.objectType : ""
        );
        form.append("note", this.note);
        form.append("detail", JSON.stringify(this.tranferData));
        this.mAxiosPost(url, form, thenCB);
      }
    },
    filterType() {
      this.filter = {
        isFormal: this.currentAddItem.memberType,
      };
    },
    removeMember() {
      this.$refs.removeMember.clear(
        this.addMemberObj[this.formType[0].key],
        this.formType[0].key
      );
    },
    getOtherAccount() {
      let url = API.coopAccountTitle + `?action=getByManualReceipt`;
      this.$http.get(url).then((res) => {
        // this.otherItem = res.data.resultData;
        this.options.options = res.data.resultData.map((item) => {
          return {
            label: `${item.code} ${item.name}`,
            value: item.id,
            code: item.code,
            name: item.name,
          };
        });
      });
    },
    getGlossary() {
      let url = API.coopGlossary;
      this.$http.get(url).then((res) => {
        this.GlossaryList = res.data.resultData.data.map((item) => {
          return {
            label: item.code,
            value: item.content,
          };
        });
      });
    },
    importGlossary() {
      if (!this.Glossary) {
        this.$message.closeAll();
        this.$message({
          type: "warning",
          message: "請先選擇詞彙",
        });
      } else {
        if (this.note == "") {
          this.$nextTick(() => {
            this.note = this.Glossary;
          });
        } else {
          this.$nextTick(() => {
            this.note += `,${this.Glossary}`;
          });
        }
      }
    },
    //此為list 綁定的回傳千分位
    resetAmount(amount, itemIndex) {
      this.works[itemIndex].amount = this.$addcomma(this.$removeComma(amount));
    },
    //此為新加項目時的金額千分位
    resetAddAmount(amount) {
      return (this.currentAddItem.amount = this.$addcomma(
        this.$removeComma(amount)
      ));
    },
    //安基選項的科目過濾回傳code
    filterAccountTitle(accountTitleId) {
      //因為上面綁定顯示的不是code + name 的組合 是分開顯示 故回傳name就好
      let name = "";
      this.accountTitle.forEach((item) => {
        if (accountTitleId == item.value) {
          name = item.name;
        }
      });
      return name;
    },
    changeDate(key) {
      setTimeout(() => {
        let date =
          parseInt($(`.${key}`).val().split("-")[0]) +
          1911 +
          $(`.${key}`).val().slice(3);

        this.currentAddItem.date = date;
        $(`.${key}`).val();
      }, 200);
    },
    backVoucher() {
      this.$router.push({
        name: "all_payment_edit",
        params: {
          id: this.$route.params.id,
          backIouNumber: this.$route.params.backIouNumber,
          backIouId: this.$route.params.backIouId,
        },
      });
    },
    openDialog(main) {
      this.dialogPrint = true;
      this.currentPrint = main;
    },
    print() {
      // 因 data 內又多包一層 main 故不能直接使用 id 須透過 row
      const url = API.coopVoucher;
      // get 參數
      const params = {
        action: "print",
        id: this.currentPrint.id,
      };

      this.mDownloadFile(url, false, "", params);
    },
    overprint() {
      const url =
        API.coopVoucher + `?id=${this.currentPrint.id}&action=overprint`;
      const thenCB = (json) => {
        this.base64 = [
          {
            data: json.resultData,
          },
        ];
        setTimeout(() => {
          this.printReport();
        }, 0);
      };

      this.mAxiosGet(url, thenCB);
    },
    printReport() {
      const url = "http://localhost:4330/transfer/print";
      // delete this.$http.defaults.headers.common["X-Jesda-Api-Key"];
      const form = new FormData();
      const vm = this;
      let data = this.base64;
      let length = data.length;
      if (length == 1) {
        form.append("test", JSON.stringify(this.base64[0].data));

        let thenCB = (result) => {
          if (result == "") {
            this.$message({
              type: "success",
              message: "成功",
            });
          } else {
            this.$message({
              type: "error",
              message: result.errorMessage,
            });
          }
        };

        fetch(url, { method: "post", body: form })
          .then((data) => (data.status != 200 ? data.json() : ""))
          .then((result) => thenCB(result));

        this.base64.splice(0, 1);
      } else if (length > 1) {
        form.append("test", JSON.stringify(this.base64[0].data));
        this.$alert("繼續列印", "提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "繼續列印",
          type: "warning",
          showClose: false,
        }).then(() => {
          this.continuePrint();
        });

        let thenCB = (result) => {
          if (result == "") {
            this.$message({
              type: "success",
              message: "成功",
            });
          } else {
            this.$message({
              type: "error",
              message: result.errorMessage,
            });
          }
        };

        fetch(url, { method: "post", body: form })
          .then((data) => (data.status != 200 ? data.json() : ""))
          .then((result) => thenCB(result));
        this.base64.splice(0, 1);
      }
    },
    continuePrint() {
      //判斷目前的長度有資料再去post
      let data = this.base64;
      if (data.length > 0) {
        this.printReport();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.fs15 {
  font-size: 15px;
}
.fx-box {
  position: relative;
  .el-icon-date {
    vertical-align: top;
  }
}
.date {
  font-size: 14px;
  display: inline-block;
  position: relative;
  margin-bottom: 10px;

  span {
    margin-top: 10px;
  }
}
.block-content ::v-deep {
  .box-card {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    .table {
      td {
        vertical-align: middle;
      }
    }
  }
}
.el-form ::v-deep {
  #listform {
    .block-content {
      padding: 15px 0px;
    }
  }
}
.label-set ::v-deep {
  .el-form-item__label {
    float: none;
  }
}
.test {
  background-image: url("https://drive.google.com/file/d/1Ny6goYaedKVu7EC8vp8xlwqqsj9eCg4V/view");
}
</style>